import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ContentWrapperStyled, StyledBackground, StyledImage } from './Error404Page.styled';

const Error404Page: React.FC = () => {
  return (
    <StyledBackground>
      <ContentWrapperStyled>
        <h1>
          <FormattedMessage id="page.404.label" defaultMessage="Oops, it looks like you’re lost." />
        </h1>

        <h3>404</h3>

        <p>
          <strong>
            <FormattedMessage
              id="page.404.text1"
              defaultMessage="The page you are looking for might have been removed or its name changed or is temporarily unavailable."
            />
          </strong>
        </p>
        <p>
          <FormattedMessage
            id="page.404.text2"
            defaultMessage="Don’t worry, you can easily get back on track to your eco friendly travel plans by offsetting the carbon footprint with our CFC Engine<sup>TM</sup>."
            values={{
              sup: chunk => <sup>{chunk}</sup>,
            }}
          />
        </p>

        <StyledImage src="/images/icons/404-person.svg" />
      </ContentWrapperStyled>
    </StyledBackground>
  );
};

export default Error404Page;
